import React from 'react';
import styled from 'styled-components';

const tableData = [
  {
    column_number: 1,
    target_column_classify_field_setup: 'Setup Standard Field (1)',
    target_field_category: 'Core Field (0)',
    target_column_type: 'bigint',
    target_column_name: 'csb_survey_production_lot_id',
    source_column_name: 'csb_survey_production_lot_id',
    column_not_used: 'Not Used (1)',
  },
  {
    column_number: 2,
    target_column_classify_field_setup: 'Setup Standard Field (1)',
    target_field_category: 'Core Field (0)',
    target_column_type: 'bigint',
    target_column_name: 'csb_survey_main_id',
    source_column_name: 'cipars_feedlot_code',
    column_not_used: 'Not Used (1)',
  },
  {
    column_number: 3,
    target_column_classify_field_setup: 'Setup Standard Field (1)',
    target_field_category: 'Core Field (0)',
    target_column_type: 'bigint',
    target_column_name: 'csb_record_group_id',
    source_column_name: 'csb_record_group_id',
    column_not_used: 'Not Used (1)',
  },
  {
    column_number: 4,
    target_column_classify_field_setup: 'Setup Standard Field (1)',
    target_field_category: 'Core Field (0)',
    target_column_type: 'bigint',
    target_column_name: 'csb_account_id',
    source_column_name: 'csb_account_id',
    column_not_used: 'Not Used (1)',
  },
  {
    column_number: 5,
    target_column_classify_field_setup: 'Setup Standard Field (1)',
    target_field_category: 'Core Field (0)',
    target_column_type: 'bigint',
    target_column_name: 'csb_survey_production_lot_upload_id',
    source_column_name: 'csb_survey_production_lot_upload_id',
    column_not_used: 'Not Used (1)',
  },
   {
    column_number: 6,
    target_column_classify_field_setup: 'Setup Standard Field (1)',
    target_field_category: 'Core Field (0)',
    target_column_type: 'integer',
    target_column_name: 'csb_pl_template_id',
    source_column_name: 'csb_pl_template_id',
    column_not_used: 'Not Used (1)',
  },
  {
    column_number: 7,
    target_column_classify_field_setup: 'Setup Standard Field (1)',
    target_field_category: 'Core Field (0)',
    target_column_type: 'varchar(128)',
    target_column_name: 'csb_pl_production_lot_code',
    source_column_name: 'feedlot_lot_name',
    column_not_used: 'Used (0)',
  },
  {
    column_number: 8,
    target_column_classify_field_setup: 'Setup Lookup Field (2)',
    target_field_category: 'Core Field (0)',
    target_column_type: 'integer',
    target_column_name: 'csb_pl_sex_id',
    source_column_name: 'sex',
    column_not_used: 'Used (0)',
  },
  {
    column_number: 9,
    target_column_classify_field_setup: 'Setup Standard Field (1)',
    target_field_category: 'Core Field (0)',
    target_column_type: 'numeric',
    target_column_name: 'csb_pl_sex_percent_steers',
    source_column_name: 'csb_pl_sex_percent_steers',
    column_not_used: 'Not Used (1)',
  },
  {
    column_number: 10,
    target_column_classify_field_setup: 'Setup Standard Field (1)',
    target_field_category: 'Core Field (0)',
    target_column_type: 'numeric',
    target_column_name: 'csb_pl_sex_percent_cows',
    source_column_name: 'csb_pl_sex_percent_cows',
    column_not_used: 'Not Used (1)',
  },
  {
    column_number: 11,
    target_column_classify_field_setup: 'Setup Standard Field (1)',
    target_field_category: 'Core Field (0)',
    target_column_type: 'numeric',
    target_column_name: 'csb_pl_sex_percent_heifers',
    source_column_name: 'csb_pl_sex_percent_heifers',
    column_not_used: 'Not Used (1)',
  },
  {
    column_number: 12,
    target_column_classify_field_setup: 'Setup Standard Field (1)',
    target_field_category: 'Core Field (0)',
    target_column_type: 'numeric',
    target_column_name: 'csb_pl_sex_percent_bulls',
    source_column_name: 'csb_pl_sex_percent_bulls',
    column_not_used: 'Not Used (1)',
  },
  {
    column_number: 13,
    target_column_classify_field_setup: 'Setup Lookup Field (2)',
    target_field_category: 'Core Field (0)',
    target_column_type: 'integer',
    target_column_name: 'csb_pl_animal_age_category_id',
    source_column_name: 'type_uk',
    column_not_used: 'Used (0)',
  },
  {
    column_number: 14,
    target_column_classify_field_setup: 'Setup Standard Field (1)',
    target_field_category: 'Core Field (0)',
    target_column_type: 'numeric',
    target_column_name: 'csb_pl_percent_calves',
    source_column_name: 'csb_pl_percent_calves',
    column_not_used: 'Not Used (1)',
  },
  {
    column_number: 15,
    target_column_classify_field_setup: 'Setup Standard Field (1)',
    target_field_category: 'Core Field (0)',
    target_column_type: 'numeric',
    target_column_name: 'csb_pl_percent_yearlings',
    source_column_name: 'csb_pl_percent_yearlings',
    column_not_used: 'Not Used (1)',
  },
  {
    column_number: 16,
    target_column_classify_field_setup: 'Setup Standard Field (1)',
    target_field_category: 'Core Field (0)',
    target_column_type: 'numeric',
    target_column_name: 'csb_pl_percent_adults',
    source_column_name: 'csb_pl_percent_adults',
    column_not_used: 'Not Used (1)',
  },
  {
    column_number: 17,
    target_column_classify_field_setup: 'Setup Lookup Field (2)',
    target_field_category: 'Core Field (0)',
    target_column_type: 'integer',
    target_column_name: 'csb_pl_origin_id',
    source_column_name: 'origin',
    column_not_used: 'Used (0)',
  },
  {
    column_number: 18,
    target_column_classify_field_setup: 'Setup Standard Field (1)',
    target_field_category: 'Core Field (0)',
    target_column_type: 'numeric',
    target_column_name: 'csb_pl_origin_percent_auction',
    source_column_name: 'csb_pl_origin_percent_auction',
    column_not_used: 'Not Used (1)',
  },
  {
    column_number: 19,
    target_column_classify_field_setup: 'Setup Standard Field (1)',
    target_field_category: 'Core Field (0)',
    target_column_type: 'numeric',
    target_column_name: 'csb_pl_origin_percent_backgrounded',
    source_column_name: 'csb_pl_origin_percent_backgrounded',
    column_not_used: 'Not Used (1)',
  },
  {
    column_number: 20,
    target_column_classify_field_setup: 'Setup Standard Field (1)',
    target_field_category: 'Core Field (0)',
    target_column_type: 'numeric',
    target_column_name: 'csb_pl_origin_percent_ranch_direct',
    source_column_name: 'csb_pl_origin_percent_ranch_direct',
    column_not_used: 'Not Used (1)',
  },
  {
    column_number: 21,
    target_column_classify_field_setup: 'Setup Lookup Field (2)',
    target_field_category: 'Core Field (0)',
    target_column_type: 'integer',
    target_column_name: 'csb_pl_brd_risk_id',
    source_column_name: 'brd_risk_category',
    column_not_used: 'Used (0)',
  },
  {
    column_number: 22,
    target_column_classify_field_setup: 'Setup Standard Field (1)',
    target_field_category: 'Core Field (0)',
    target_column_type: 'numeric',
    target_column_name: 'csb_pl_brd_risk_percent_low',
    source_column_name: 'csb_pl_brd_risk_percent_low',
    column_not_used: 'Not Used (1)',
  },
  {
    column_number: 23,
    target_column_classify_field_setup: 'Setup Standard Field (1)',
    target_field_category: 'Core Field (0)',
    target_column_type: 'numeric',
    target_column_name: 'csb_pl_brd_risk_percent_medium',
    source_column_name: 'csb_pl_brd_risk_percent_medium',
    column_not_used: 'Not Used (1)',
  },
  {
    column_number: 24,
    target_column_classify_field_setup: 'Setup Standard Field (1)',
    target_field_category: 'Core Field (0)',
    target_column_type: 'numeric',
    target_column_name: 'csb_pl_brd_risk_percent_high',
    source_column_name: 'csb_pl_brd_risk_percent_high',
    column_not_used: 'Not Used (1)',
  },
  {
    column_number: 25,
    target_column_classify_field_setup: 'Setup Lookup Field (2)',
    target_field_category: 'Core Field (0)',
    target_column_type: 'integer',
    target_column_name: 'csb_pl_quarter_of_year_closeout_id',
    source_column_name: 'closeout',
    column_not_used: 'Used (0)',
  },
  {
    column_number: 26,
    target_column_classify_field_setup: 'Setup Standard Field (1)',
    target_field_category: 'Core Field (0)',
    target_column_type: 'integer',
    target_column_name: 'csb_pl_n_animals_inhd_in',
    source_column_name: 'Used (0)', // This looks like a typo in your provided data. Corrected in next point.
    column_not_used: 'Used (0)',
  },
  {
    column_number: 27,
    target_column_classify_field_setup: 'Setup Standard Field (1)',
    target_field_category: 'Core Field (0)',
    target_column_type: 'integer',
    target_column_name: 'csb_pl_n_animals_railed',
    source_column_name: 'csb_pl_n_animals_railed',
    column_not_used: 'Not Used (1)',
  },
  {
    column_number: 28,
    target_column_classify_field_setup: 'Setup Standard Field (1)',
    target_field_category: 'Core Field (0)',
    target_column_type: 'integer',
    target_column_name: 'csb_pl_n_animals_dead',
    source_column_name: 'deaths',
    column_not_used: 'Used (0)',
  },
  {
    column_number: 29,
    target_column_classify_field_setup: 'Setup Standard Field (1)',
    target_field_category: 'Core Field (0)',
    target_column_type: 'integer',
    target_column_name: 'csb_pl_n_animals_slaughtered',
    source_column_name: 'hd_out',
    column_not_used: 'Used (0)',
  },
  {
    column_number: 30,
    target_column_classify_field_setup: 'Setup Lookup Field (2)',
    target_field_category: 'Core Field (0)',
    target_column_type: 'integer',
    target_column_name: 'csb_pl_source_weight_in_units_id',
    source_column_name: 'csb_pl_source_weight_in_units_id',
    column_not_used: 'Not Used (1)',
  },
  {
    column_number: 31,
    target_column_classify_field_setup: 'Setup Standard Field (1)',
    target_field_category: 'Core Field (0)',
    target_column_type: 'numeric',
    target_column_name: 'csb_pl_source_weight_in_value',
    source_column_name: 'csb_pl_source_weight_in_value',
    column_not_used: 'Not Used (1)',
  },
  {
    column_number: 32,
    target_column_classify_field_setup: 'Setup Multiple Target Fields (3)',
    target_field_category: 'Core Field (0)',
    target_column_type: 'numeric',
    target_column_name: 'csb_pl_avg_weight_in_kgs',
    source_column_name: 'avg_in_weight',
    column_not_used: 'Used (0)',
  },
  {
    column_number: 33,
    target_column_classify_field_setup: 'Setup Lookup Field (2)',
    target_field_category: 'Core Field (0)',
    target_column_type: 'integer',
    target_column_name: 'csb_pl_source_weight_out_units_id',
    source_column_name: 'csb_pl_source_weight_out_units_id',
    column_not_used: 'Not Used (1)',
  },
  {
    column_number: 34,
    target_column_classify_field_setup: 'Setup Standard Field (1)',
    target_field_category: 'Core Field (0)',
    target_column_type: 'numeric',
    target_column_name: 'csb_pl_source_weight_out_value',
    source_column_name: 'csb_pl_source_weight_out_value',
    column_not_used: 'Not Used (1)',
  },
  {
    column_number: 35,
    target_column_classify_field_setup: 'Setup Multiple Target Fields (3)',
    target_field_category: 'Core Field (0)',
    target_column_type: 'numeric',
    target_column_name: 'csb_pl_avg_weight_out_kgs',
    source_column_name: 'avg_out_weight',
    column_not_used: 'Used (0)',
  },
  {
    column_number: 36,
    target_column_classify_field_setup: 'Setup Standard Field (1)',
    target_field_category: 'Core Field (0)',
    target_column_type: 'date',
    target_column_name: 'csb_pl_avg_date_in',
    source_column_name: 'avg_in_date',
    column_not_used: 'Used (0)',
  },
  {
    column_number: 37,
    target_column_classify_field_setup: 'Setup Standard Field (1)',
    target_field_category: 'Core Field (0)',
    target_column_type: 'date',
    target_column_name: 'csb_pl_avg_date_out',
    source_column_name: 'avg_out_date',
    column_not_used: 'Used (0)',
  },
  {
    column_number: 38,
    target_column_classify_field_setup: 'Setup Standard Field (1)',
    target_field_category: 'Core Field (0)',
    target_column_type: 'numeric',
    target_column_name: 'csb_pl_total_days_on_feed',
    source_column_name: 'dof',
    column_not_used: 'Used (0)',
  },
  {
    column_number: 39,
    target_column_classify_field_setup: 'Setup Standard Field (1)',
    target_field_category: 'Core Field (0)',
    target_column_type: 'numeric',
    target_column_name: 'csb_pl_total_head_days',
    source_column_name: 'head_days',
    column_not_used: 'Used (0)',
  },
  {
    column_number: 40,
    target_column_classify_field_setup: 'Setup Standard Field (1)',
    target_field_category: 'Core Field (0)',
    target_column_type: 'varchar',
    target_column_name: 'csb_pl_notes',
    source_column_name: 'csb_pl_notes', // Corrected from 'csb_pl_notescsb_pl_notes'
    column_not_used: 'Not Used (1)',
  },
];

const TableWrapper = styled.div`
  overflow-x: auto; /* Enables horizontal scrolling for small screens */
  margin-top: 2em; /* Added margin above the table */
  margin-bottom: 2em;
`;

const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  /*table-layout: fixed; Maintains column widths */
  font-size: 0.9em; /* Slightly smaller font for tables */
  min-width: 1200px; /* Set a minimum width for the table to prevent squishing */
  color: ${({ theme }) => theme.text}; 
`;

const TableHeader = styled.th`
  padding: 8px;
  border: 1px solid #999;
  text-align: left;
  font-weight: bold;
  white-space: nowrap;
  background-color: ${({ theme }) => theme.headerBg}; /* Use theme for header background */
  color: ${({ theme }) => theme.headerText}; /* Use theme for header text color */
  position: sticky; /* Make headers sticky */
  top: 0; /* Stick to the top when scrolling */
  z-index: 1; /* Ensure headers appear above scrolling content */
`;

const TableCell = styled.td`
  padding: 8px;
  border: 1px solid #ddd;
  text-align: left;
  height: 15pt; /* Original height */
  /* Align column_number to the right */
  &:nth-child(1) {
    text-align: right;
  }
`;

const TableRow = styled.tr`
  &:nth-child(even) { /* Apply a different background to even rows */
  }
`;

const CoreTemplateTable = () => {
  return (
    <TableWrapper>
      <h4>Core Template: Associated Core Template Fields</h4> {/* Changed to h4 to match SectionTitle */}
      <StyledTable>
        <thead>
          <tr>
            <TableHeader>column_number</TableHeader>
            <TableHeader>target_column_classify_field_setup</TableHeader>
            <TableHeader>target_field_category</TableHeader>
            <TableHeader>target_column_type</TableHeader>
            <TableHeader>target_column_name</TableHeader>
            <TableHeader>source_column_name</TableHeader>
            <TableHeader>column_not_used</TableHeader>
          </tr>
        </thead>
        <tbody>
          {tableData.map((row, index) => (
            <TableRow key={index}>
              <TableCell>{row.column_number}</TableCell>
              <TableCell>{row.target_column_classify_field_setup}</TableCell>
              <TableCell>{row.target_field_category}</TableCell>
              <TableCell>{row.target_column_type}</TableCell>
              <TableCell>{row.target_column_name}</TableCell>
              <TableCell>{row.source_column_name}</TableCell>
              <TableCell>{row.column_not_used}</TableCell>
            </TableRow>
          ))}
        </tbody>
      </StyledTable>
    </TableWrapper>
  );
};

export default CoreTemplateTable;